<template>
  <div style="position: relative">
    <div v-if="loading" class="progress-bar">
      <div class="progress-bar-value"></div>
    </div>
    <div v-if="loading" class="loading-overlay"></div>
    <h3>
      <feather-icon
        size="25"
        style="margin: 0px 8px"
        icon="PhoneCallIcon"
      />معلومات التواصل
    </h3>
    <hr />
    <app-collapse>
      <contact-card
        :title="ngo.info.name_ar"
        class="border rounded contact-card my-1"
        :contactMethods="ngo.contacts"
        :isNgo="true"
        :branchInfo="ngo.info"
      />
    </app-collapse>

    <app-collapse v-for="(branch, index) in branches" :key="index">
      <contact-card
        :title="branch.info.name_ar"
        class="border rounded contact-card my-1"
        :contactMethods="branch.contacts"
        :isNgo="false"
        :branchInfo="branch.info"
      />
    </app-collapse>
  </div>
</template>

<script>
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import ContactCard from "../../components/ContactCard";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    ContactCard,
    AppCollapse,
  },
  computed: {
    ...mapGetters("NgoProfile/ContactInfo", ["ngo", "branches", "loading"]),
  },
  methods: {
    ...mapActions("NgoProfile/ContactInfo", ["fetchContactInfo"]),
  },
  created() {
    this.fetchContactInfo();
  },
};
</script>

<style>
.contact-card .card {
  margin-bottom: 0px;
}
</style>
